export default __webpack_public_path__ + "images/ET.475a6ec.png";